module.exports = __webpack_public_path__ + "static/p-1-3914ecc2830be80dd7add8a496c16a03.jpg";